import { render, staticRenderFns } from "./PolicyFormCarrierProduct.vue?vue&type=template&id=423cbd34&scoped=true&"
import script from "./PolicyFormCarrierProduct.vue?vue&type=script&lang=ts&"
export * from "./PolicyFormCarrierProduct.vue?vue&type=script&lang=ts&"
import style0 from "./PolicyFormCarrierProduct.vue?vue&type=style&index=0&id=423cbd34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "423cbd34",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
